import { faAdd, faBracketsCurly } from "@fortawesome/pro-regular-svg-icons";
import React from "react";

import { Button } from "src/base-components/Button";
import { Icon } from "src/base-components/Icon";

export type JsonSchemaEmptyStateProps = {
  immutable: boolean;
  onAddField: () => void;
  onOpenRawJsonView?: () => void;
};

export const JsonSchemaEmptyState: React.FC<JsonSchemaEmptyStateProps> = ({
  immutable,
  onAddField,
  onOpenRawJsonView,
}) => {
  return (
    <div
      className="flex flex-col items-center justify-center py-4 text-center"
      data-loc="json-schema-empty-state"
    >
      <div className="mb-4 rounded-xl bg-indigo-100 p-4 text-indigo-600">
        <Icon icon={faBracketsCurly} size="lg" />
      </div>
      <h1 className="mb-2 text-gray-800 font-inter-semibold-13px">
        Create structured output
      </h1>
      <p className="mb-4 max-w-xs text-gray-500 font-inter-normal-12px">
        Click below to start creating your structured output by adding a field
        or creating from JSON schema.
      </p>
      <div className="flex items-center gap-4">
        <div className="w-[120px]">
          <Button
            dataLoc="add-jsonschema-field"
            disabled={immutable}
            iconLeft={faAdd}
            size="sm"
            variant="secondary"
            fullWidth
            onClick={onAddField}
          >
            Add field
          </Button>
        </div>
        {onOpenRawJsonView && (
          <>
            <span className="text-gray-400 font-inter-normal-12px">or</span>
            <div className="w-[120px]">
              <Button
                dataLoc="open-json-schema-editor"
                disabled={immutable}
                iconLeft={faBracketsCurly}
                size="sm"
                variant="secondary"
                fullWidth
                onClick={onOpenRawJsonView}
              >
                JSON schema
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
